var _defs, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCustomer = function SvgCustomer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Customer_svg__ae562fc9-9141-4705-825b-113448fbde2e{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px}"))), /*#__PURE__*/React.createElement("g", {
    id: "Customer_svg__ed9aad2e-420b-46f7-8230-49bbc1d0e51f",
    "data-name": "Customer"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h250v250H0z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Customer_svg__ae562fc9-9141-4705-825b-113448fbde2e",
    cx: 125,
    cy: 70.96,
    r: 20.64
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Customer_svg__ae562fc9-9141-4705-825b-113448fbde2e",
    d: "M138.5 86.57a30.93 30.93 0 0 1 17.5 27.86H94a30.93 30.93 0 0 1 17.5-27.86M120 177.47l-.73 22.21h-33.1l-19.8-27.44-19.06-54.34a3.23 3.23 0 0 1 1.81-4l4.64-1.92a3.2 3.2 0 0 1 4 1.39l21.43 38.29 13.48 7.78v-16.93a6.43 6.43 0 0 1 6.43-6.44h5a6.43 6.43 0 0 1 6.43 6.44v22.11a12.86 12.86 0 0 1 9.47 12.85ZM130 177.47l.73 22.21h33.07l19.8-27.44 19.06-54.34a3.23 3.23 0 0 0-1.81-4l-4.64-1.92a3.2 3.2 0 0 0-4 1.39l-21.43 38.29-13.48 7.78v-16.93a6.43 6.43 0 0 0-6.43-6.44h-5a6.43 6.43 0 0 0-6.43 6.44v22.11a12.86 12.86 0 0 0-9.44 12.85Z"
  }))));
};

export default SvgCustomer;